export default __webpack_public_path__ + "static/apy@2x-4be634a43c5c2602806f96a0f2928c3e.png";